export default __webpack_public_path__ + "static/Hero-81d473912275e5fa23991004750b4b88.gif";